import { action, observable } from 'mobx';

import Api from 'tm3-core/api';
import lazy from './lazy-loader';

class TemplatesStore {
  @observable loading = false;
  @observable folders = [];
  @observable files = [];

  @action.bound
  load() {
    this.loading = true;

    return lazy('/api/templates')
      .then(({ body }) => {
        const { folders, files } = body;
        this.folders.replace(folders);
        this.files.replace(files);
        this.loading = false;
      })
      .catch(() => {
        return console.error('Error loadingTemplates templates');
      });
  }

  @action.bound
  reload() {
    lazy.clear('/api/templates');
    return this.actions.load();
  }

  @action.bound
  delete(path, isGlobal) {
    path = path.replace(/\\|\//g, '%2F');
    return Api.post('/api/delete', { path: this.path(path), isGlobal }).then((res) => {
      return this.reloadTemplates();
    });
  }

  @action.bound
  rename(path, newName, isGlobal) {
    if (isGlobal) {
      this.rename(path, `${path}.hidden`);
    }
    const options = this.postOptions(this.path(path), this.name(newName), true, isGlobal);
    return Api.post('/api/rename', options).then((res) => {
      return this.reload();
    });
  }

  @action.bound
  copy(path, newName, isGlobal) {
    const options = this.postOptions(path, this.name(newName), true, isGlobal);
    return Api.post('/api/copy', options).then((res) => {
      return this.actions.reload();
    });
  }

  path(path) {
    return path.replace(/\\|\//g, '%2F');
  }

  name(name) {
    name.replace(/\\|\//g, '%2F');
  }

  postOptions(path, newName, overwrite, isGlobal) {
    return { path, newName, overwrite, isGlobal };
  }
}

export default new TemplatesStore();
export { TemplatesStore };
